"use client";

import { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import Image from "next/image";
import arrowLeft from "../../lib/carousel/arrow_left.png";
import arrowRight from "../../lib/carousel/arrow_right.png";
import { useRouter } from "next/navigation";
import PostCard from "./PostCard/index";
const styles = new Proxy({"BlogTeaser":"BlogTeaser-f2761","Title":"Title-f2761","Subtitle":"Subtitle-f2761","PostsRow":"PostsRow-f2761","CarouselWrap":"CarouselWrap-f2761","SlideOuter":"SlideOuter-f2761","col-lg-4":"col-lg-4-f2761","Controls":"Controls-f2761","Dots":"Dots-f2761","Dot":"Dot-f2761","DotActive":"DotActive-f2761","ArrowBtn":"ArrowBtn-f2761","CTA":"CTA-f2761"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./BlogTeaserSlider.scss";*/
import { Post } from "./types";

export default function BlogTeaserCarousel({ posts }: { posts: Post[] }) {
  const sliderRef = useRef<Slider>(null);
  const [active, setActive] = useState(false);
  const [current, setCurrent] = useState(0);
  const router = useRouter();

  useEffect(() => {
    const check = () => setActive(window.innerWidth < 992);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!active) return null;

  const SETTINGS: Settings = {
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    cssEase: "ease",
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.CarouselWrap}>
      <Slider ref={sliderRef} {...SETTINGS} className="BlogTeaserSlider">
        {posts.map((post, i) => (
          <div key={post.id} className={styles.SlideOuter}>
            <PostCard
              post={post}
              className="px-3"
              router={router}
              isFirst={i === 0}
            />
          </div>
        ))}
      </Slider>
      <div className={styles.Controls}>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label="Previous"
        >
          <Image src={arrowLeft} alt="Previous" width={20} height={29} />
        </button>
        <ul className={styles.Dots}>
          {posts.map((_, i) => (
            <li
              key={i}
              className={i === current % posts.length ? styles.DotActive : styles.Dot}
              onClick={() => sliderRef.current?.slickGoTo(i)}
            />
          ))}
        </ul>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickNext()}
          aria-label="Next"
        >
          <Image src={arrowRight} alt="Next" width={20} height={29} />
        </button>
      </div>
    </div>
  );
}
